import React from 'react';
import HeroSection from './HeroSection';
import AboutUsSection from './AboutUsSection';
import MenuSection from './MenuSection';
import TacoTuesdaySpecials from './TacoTuesdaySpecials';
import Testimonials from './Testimonials';
import Newsletter from './Newsletter';

const IndexPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center w-full mt-[15vh] md:mt-[0]">
      {/* 1) Hero Section */}
      <HeroSection />

      {/* 2) About Us Section */}
      <AboutUsSection />

      {/* 3) ...Any other sections or components... */}
      <MenuSection />

      <TacoTuesdaySpecials />

      <Testimonials />

      <Newsletter />
    </div>
  );
};

export default IndexPage;
